<template>	   
	<div>
		<hr>
    <v-layout row wrap>
      <v-flex xs4 pa-1> 
        <label for="">Variables</label>
        <v-autocomplete solo
          :items="variables"
          item-value="id"
          item-text="name"
          v-model="filters.id_variable"
          label="Variables"
        >
          <template v-slot:item="data">
            <v-list-item-action @click="data.item.active = !data.item.active">
              <v-icon>fas fa-subscript</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
              <v-list-item-sub-title>Tipo: {{ data.item.category }} | Nivel: {{ data.item.level }}  </v-list-item-sub-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs4 pa-1> 
        <label for="">Fecha inicial</label>
        <v-text-field
          name="name" v-model="filters.dateInit"
          label="Fecha" solo
          id="id" type="date"
        ></v-text-field>
      </v-flex>
      <v-flex xs4 pa-1> 
        <label for="">Fecha Final</label>
        <v-text-field
          name="name" v-model="filters.dateEnd"
          label="Fecha" solo
          id="id" type="date"
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-switch label="Hacer seguimiento de localidad"  v-model="filters.followLocate"></v-switch>
      </v-flex>
      <v-flex xs6 pa-1 v-if="filters.followLocate">
        <label for="">Localidades</label>
        <v-autocomplete solo
            :items="localities"
            item-text="label" 
            @change="getGraphicsData()"
            item-value="value" 
            v-model="filters.id_point"
            label="Localidades"
          >
			     <template v-slot:item="data">			     		
		    		<v-list-item-action>
		          <v-icon>fas fa-globe-americas</v-icon>
		        </v-list-item-action>
			    	<v-list-item-content>
			        <v-list-item-title v-html="data.item.label"></v-list-item-title>
			        <v-list-item-sub-title><strong>Provincia:</strong> {{ data.item.province }}</v-list-item-sub-title>
			      </v-list-item-content>
			    </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs12>
      	<v-layout row wrap>
      	  <v-flex xs5>
        		<v-btn color="success"  @click="getArrayDates()"><v-icon>fas fa-search</v-icon></v-btn>
      	  </v-flex>
      	  <v-flex xs7>
		        <v-text-field 
		          name="time"
		          label="Velocidad de la animación"
		          id="id" v-model="animation.time" 
		         	suffix="Segundos"
		        ></v-text-field>
      	  </v-flex>
      	</v-layout>
      </v-flex>
      <v-flex xs12>
      		<v-card-title primary-title class="text-md-center">
      			<h3 v-if="animation.dates.length > 0">
      		  	 Fecha: {{ animation.dates[animation.value] }}
      			</h3>
      		</v-card-title>
         <v-card-text>
		      <v-slider
		        @change="getDate()"
						@click:prepend="playDate()"
		        v-model="animation.value"
		        :step="1" 
		        :max="animation.dates.length - 1"
		        ticks="always""
						:prepend-icon="animation.icon"
		      ></v-slider>
		    </v-card-text>
      </v-flex>
    </v-layout>
		<v-container v-if="!loadingPage && !noDataError">
			<v-card :min-height="500">
				<v-card-text v-if="filters.followLocate">
						<line-chart :chart-data="lineChartData" :options="chartOptions"></line-chart>
		    </v-card-text>   
        <v-card-text>    
          <l-map 
    				:key="animation.value"
    			  id="map"
    				style="height: 500px;  margin-right: 5px " 
			      @update:center="centerUpdated"
    				:zoom.sync="zoom" 
    				:options="mapOptions"  
    				:center="center"  
    				:min-zoom="minZoom" 
    				:max-zoom="maxZoom" >
    			 	<l-control-sum position="topleft"></l-control-sum>
              <l-control-layers 
              :position="layersPosition"/>
              <l-tile-layer 
              	v-for="(tileProvider, index) in tileProviders" 
              	:key="index"
                layerType="base" 
              	:name="tileProvider.name" 
              	:visible="tileProvider.visible" 
              	:url="tileProvider.url" 
              	:attribution="tileProvider.attribution" 
              	:token="token" 
              	:id="tileProvider"/>
               <l-circle 
                  v-for="point in heatPoints"
                  v-if="point.geometry == 'POINT'"
                  :lat-lng="[point.lat,point.lng]"
                  :radius="4500"
                  :color="point.color"
                  @click="activeDialog('point', point)"
                />
                <l-polygon 
                  v-for="point in heatPoints"
                  v-if="point.geometry == 'POLYGON'"
                  :lat-lngs="point.geo"
                  :color="point.color"
                  @click="activeDialog('point', point)"
                />
              </l-map>
          </l-map>
          
          	<v-layout row justify-center v-if="loadingMap">
              <v-progress-circular indeterminate></v-progress-circular>
            </v-layout>
         </v-card-text>    
		      
      </v-card>
		</v-container>
		<v-container v-if="loadingPage && !noDataError">
		  	<v-layout row wrap>
		  	 	<v-flex xs4 offset-xs4 class="text-md-center">
		  	 	  <v-progress-circular
				      :size="70"
				      :width="7"
				      color="blue"
				      indeterminate
			    ></v-progress-circular> 
	  	 	</v-flex> 
	  	</v-layout>
		</v-container>
		<v-container v-if="noDataError">
		 	<v-layout row wrap>
		 		<v-flex xs12 class="text-md-center">
		 			<h3 class="headline" color="error">Datos no encontrados</h3>
		 		</v-flex>	  
		 	</v-layout>	
		</v-container>
	</div>
</template>
<script>
  import { latLng, Icon, icon } from 'leaflet'
	export default{
		created() {
			
		},
		mounted(){
		  this.getVariables();
		  this.getLocalities();
    },
		props: [
			
		],
		data(){
			return {
        headers: [
          { text: 'Nombre', value: 'name'},
          { text: 'Valor', value: 'value' },
          { text: 'Tipo', value: 'type' },
          { text: 'Acciones', value: 'actions' },
        ],
        searchDatatable: '',
        loadingMap: false,
        heatActive: true,
        dialog: false,
        maxZoomHeat: 4,
				minOpacity: 0.25,
        configDialog: false,
        baseRoute: process.env.VUE_APP_URL + 'api/gis',
        filters: {
          id_variable: '',
          id_point: '',
          dateInit: '',
          dateEnd: '',
          followLocate: false,
          date: ''
        },
        variables: [],
				loadingPage: false,
				points: [], //Apidefinition
				center: [-22.486628,-63.773381], //Apidefinition
				init: 0,
				mapActive: true,
        heatMaxActive: false,
				radius: 0,
				blur: 0,
        token: 'pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
        zoom:4,
				tileProviders: [
					{
						name: 'Carreteras',
						visible: true,
						id:'',
						key: 1,
						url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: 'Mundo sano',
					},
					{
						name: 'Satelite 1',
						visible: false,
						id:'',
						key: 2,
						url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          	attribution: 'Mundo sano - Centro para la prevencion de chagas',
					},
					{
						name: 'Satelite 2',
				    id: 'mapbox.satellite',
						visible: false,
            key: 3,
            accessToken: 'pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
            attribution: 'Mundo sano - Centro para la prevencion de chagas',
					},
				],
        clusterOptions: {
          
        },
        zoomPosition: 'topleft',
				mapOptions: { zoomControl: false , attributionControl: false },
				attributionPosition: 'bottomright',
        layersPosition: 'topright',
        attributionPrefix: 'Vue2Leaflet',    
        maxZoom:15,
        minZoom: 3,
       	heatPoints: [],
       	markers: [],
       	dataCollectionBar: '',
				dataCollectionPie: '',
				noDataError: false,
        rotate: 270,   
        animation: {
        	interval: {},
        	time: 5,
        	dates: [],
        	active: false,
        	icon: 'fas fa-play',
        	value: ''
        },
        lineChartData: {
        	labels: [],
        	datasets: []
        },
        chartOptions: {
		      responsive: true,
		      maintainAspectRatio: false
		    },
		    chartData: {
		    	labels: [],
		    	data: [],
		    	title: '' 
		    },
			}
		},
		methods: {
			getLocalities(){
				//window.clearInterval(this.interval);
				axios.get(this.baseRoute + '/district/getSelect/habilited').then((res) => {
					this.localities = res.data;
				}).catch((error) => {

				});
			},
      getVariables(){
        axios.get(this.baseRoute + '/variables/getSelect').then((res) => {
          this.variables = res.data;
        }).catch((error) => {
          this.alert = {
            messague: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
            color: 'error',
            active: true,
            icon: 'fas fa-bell',            
          }
        });
      },
      setCenter(item){
        this.center = [item.lat, item.lng];
      },  
      getArrayDates(){
      	axios.put(this.baseRoute + '/results/getArrayDates', this.filters).then((res) => {
      		this.animation.dates = res.data;
      		this.animation.value = 0;
      		this.getDate();
      	}).catch((error) => {

      	});
      },
      getGraphicsData(){
      	if(this.filters.followLocate){
	      	let graphicFilters = this.filters;
	      	if(this.animation.active){
	      		graphicFilters = this.animation.dates[this.animation.value];
	      	}
	      	axios.put(this.baseRoute + '/results/getGraphicsData', graphicFilters).then((res) => {
						this.chartData = {
							labels: res.data.labels,
				    	data: res.data.dataset,
				    	title: res.data.label 
						};
      			this.setChart();
					}).catch((error) =>  {

					});
      	}
      },
      getCurrentDate(){
      	this.animation.value++;
      	this.getDate();
      	if(this.animation.value == this.animation.dates.length - 1){
      		this.playDate();
      	}
      },
      getDate(){
      	this.filters.date = this.animation.dates[this.animation.value];
      	console.log(this.filters.date);
      	axios.put(this.baseRoute + '/results/getCurrentDate', this.filters).then((res) => {
      		this.mapActive = !this.mapActive;
      		this.heatPoints = res.data.mapData
      		if(this.filters.followLocate && this.animation.active){
      			this.chartData.data.push(res.data.graphicValue.value);
      			this.chartData.labels.push(res.data.graphicValue.date);
      			this.setChart();
      		}
      	})
      },
      playDate(){
      	if(this.animation.active){
      		clearInterval(this.animation.interval);
      		this.animation.active = false;
      		this.animation.icon = 'fas fa-play';
      		this.getGraphicsData();
      	}else{
      		this.animation.value = 0;
      		this.animation.interval = window.setInterval(function(){this.getCurrentDate();}.bind(this), this.animation.time * 1000);
      		this.animation.icon = 'fas fa-pause';
      		this.chartData.data = [];
      		this.chartData.labels = [];
    			this.setChart();	
      		this.animation.active = true;
      	}	
      },
      zoomUpdated (zoom) {
      	this.zoom = zoom;
	    },
	    centerUpdated (center) {
	      this.center = center;
	    },
	    setChart(){
	    	this.lineChartData = {
					labels: this.chartData.labels,
					datasets: [
						{	
							label: this.chartData.title,
							backgroundColor: 'transparent',
							borderColor:'#' + Math.floor(Math.random()*16777215).toString(16),
							data: this.chartData.data
						},
					]
				}
	    }
		},
		watch: {
			
		},
		computed: {
		},
	}
</script>